<div class="main-content">
  <div class="app-side-menu-wrapper">
    <app-side-menu></app-side-menu>
  </div>
  <div class="right-content">

    <!-- Slide-in filter panel -->
    <div class="app-shop-filter" [ngClass]="{ 'open': isMenuOpen }">
      @if (isMenuOpen) {
      <app-stats-filter [previousSearchModel]="previousSearchData" [statsViewModel]="statsViewModel"
        (searchStatsEvent)="SearchStats($event)" (isOpen)="closeMenu()"
        class="position-absolute top-0 right-0 w-100 h-100">
      </app-stats-filter>
      }
    </div>

    <app-top-menu></app-top-menu>

    <div class="content mx-2">

      <!-- Loading overlay -->
      @if (isLoading) {
      <div class="loading-container" role="alert" aria-live="assertive">
        <app-loading frameborder="0"></app-loading>
      </div>
      }

      <!-- Action bar -->
      <div class="d-flex flex-row stats-action-bar">
        <div class="d-flex flex-row" style="gap: 16px;">
          <button class="filter-btn" [disabled]="!isViewModelLoaded" aria-label="Abrir filtros" (click)="toggleMenu()">
            <span>Filtros</span>
            <img src="../../../assets/Icons/filterIcon.png" alt="Ícone de filtros">
          </button>
        </div>
      </div>

      <!-- ═══════════════════════════════════════════════════════════════════
           MAIN STATS CONTENT
           ═══════════════════════════════════════════════════════════════════ -->
      <div id="statistics-content" [hidden]="isLoading">

        <!-- ─────────────────────────────────────────────────────────────────
             1. ANNUAL CONSUMPTION CHART  (always expanded, change 1/2/3)
             ───────────────────────────────────────────────────────────────── -->
        <div class="statistics-card-100">
          <!-- Header summary row -->
          <div class="chart-summary-header">
            <span class="chart-summary-label">
              Consumos
              {{ (previousSearchData.startDate || currentYearStart) | date:'dd/MM/yyyy' }}
              -
              {{ (previousSearchData.endDate || todayDate) | date:'dd/MM/yyyy' }}
            </span>
            <div class="chart-summary-values">
              <span class="chart-summary-total">
                Total: <strong>{{ formatMoney(totalPurchasesValue) }}</strong>
              </span>
            </div>
            <button type="button" (click)="DownloadAnnualConsumptionData()" [disabled]="isLoading"
              aria-label="Exportar dados estatísticos" class="export-btn export-btn-sm">
              <span>Exportar dados</span>
              <img src="../../../assets/Icons/ExportIcon.png" alt="Ícone de exportar">
            </button>
          </div>
          <!-- Período homólogo selector + legend -->
          <div class="chart-toolbar">
            <div class="homologo-toggle" role="group" aria-label="Comparar com período homólogo">
              <span class="homologo-toggle-label">Período homólogo</span>
              <button type="button" class="view-toggle-btn view-toggle-btn-sm" [class.active]="!homologoPeriod"
                [disabled]="isLoading" [attr.aria-pressed]="!homologoPeriod"
                (click)="onHomologoPeriodChange(null)">
                Nenhum
              </button>
              <button type="button" class="view-toggle-btn view-toggle-btn-sm" [class.active]="homologoPeriod === 'N-1'"
                [disabled]="isLoading" [attr.aria-pressed]="homologoPeriod === 'N-1'"
                (click)="onHomologoPeriodChange('N-1')">
                N-1
              </button>
              <button type="button" class="view-toggle-btn view-toggle-btn-sm" [class.active]="homologoPeriod === 'N-2'"
                [disabled]="isLoading" [attr.aria-pressed]="homologoPeriod === 'N-2'"
                (click)="onHomologoPeriodChange('N-2')">
                N-2
              </button>
              @if (isHomologoLoading) {
              <span class="homologo-loading" role="status">A carregar…</span>
              }
            </div>

            @if (isHomologoVisible) {
            <div class="chart-legend" aria-label="Legenda do gráfico">
              <span class="chart-legend-item">
                <span class="chart-legend-swatch chart-legend-swatch-current"></span>
                {{ currentSeriesLabel }}
                <strong>{{ formatMoney(totalPurchasesValue) }}</strong>
              </span>
              <span class="chart-legend-item">
                <span class="chart-legend-swatch chart-legend-swatch-homologo"></span>
                {{ homologoSeriesLabel }} ({{ homologoPeriod }})
                <strong>{{ formatMoney(homologoTotal) }}</strong>
              </span>
              @if (homologoVariation) {
              <span class="chart-legend-variation"
                [class.chart-legend-variation-up]="homologoVariationIsPositive"
                [class.chart-legend-variation-down]="!homologoVariationIsPositive">
                {{ homologoVariation }}
              </span>
              }
            </div>
            }
          </div>

          <!-- Chart canvas -->
          <!-- Horizontally scrollable on narrow screens: each month has a minimum
               column width; the y-axis is mirrored on a sticky overlay canvas. -->
          <div class="stats-chart-wrapper">
            <div class="stats-chart-scroll" #consumptionChartScroll (scroll)="UpdateStickyYAxisVisibility()">
              <div class="stats-chart-inner" [style.min-width.px]="consumptionChartMinWidth">
                <canvas #consumptionChart id="consumptionChart"></canvas>
              </div>
            </div>
            <canvas #consumptionYAxis class="stats-chart-yaxis" aria-hidden="true"></canvas>
          </div>
        </div>

        <!-- ─────────────────────────────────────────────────────────────────
             4. CONSUMPTION DETAIL TABLE  (open by default, change 4)
             ───────────────────────────────────────────────────────────────── -->
        <div class="statistics-card-100 consumption-detail-card">
          <div class="consumption-header">

            <!-- Row 1 -->
            <div class="consumption-header-top">
              <label class="consumption-title">
                Consumos detalhados
              </label>

              <button type="button" class="export-btn export-btn-sm" (click)="DownloadConsumptionTable()"
                aria-label="Exportar consumo detalhado">

                Exportar dados
                <img src="../../../assets/Icons/ExportIcon.png" alt="">
              </button>
            </div>

            <!-- Row 2 -->
            <div class="view-toggle-group" role="group" aria-label="Modo de visualização">

              <button class="view-toggle-btn" [class.active]="consumptionViewMode === 'simples'"
                [disabled]="isTableLoading"
                (click)="setConsumptionView('simples')">
                Vista simples
              </button>

              <button class="view-toggle-btn" [class.active]="consumptionViewMode === 'completa'"
                [disabled]="isTableLoading"
                (click)="setConsumptionView('completa')">
                Vista completa
              </button>

            </div>

          </div>

          <!-- ═══════════════════════════════════════════════════════════════
               Table container — scoped loading overlay for pagination /
               view-mode switches (section 3 update).
               ═══════════════════════════════════════════════════════════ -->
          <div class="table-container">

            @if (isTableLoading) {
            <div class="table-loading-overlay" role="alert" aria-live="polite">
              <app-loading frameborder="0"></app-loading>
            </div>
            }

            <!-- Vista simples -->
            @if (consumptionViewMode === 'simples') {

            <div class="scrollable-table">
              <table class="table stats-table" id="consumptionDetailTable"
                aria-label="Tabela de consumo detalhado - vista simples">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Designação</th>
                    <th>Qtd do Produto Faturada</th>
                    <th>Qtd do Produto Bónus</th>
                    @if (loggedUser.role !== 'Laboratorio') {
                    <th>Valor do Produto Faturado</th>
                    }
                    <th>{{ loggedUser.role === 'Laboratorio' ? 'Cliente' : 'Laboratório' }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of consumptionTableData; track row) {
                  <tr>
                    <td>{{ row.reference ?? '—' }}</td>
                    <td>{{ row.designation }}</td>
                    <td>{{ row.quantityCashed }}</td>
                    <td>{{ row.quantityBonus }}</td>
                    @if (loggedUser.role !== 'Laboratorio') {
                    <td>{{ formatMoney(row.valueCashed) }}</td>
                    }
                    <td>{{ row.laboratoryName ?? '—' }}</td>
                  </tr>
                  }
                  @if (!consumptionTableData.length) {
                  <tr>
                    <td colspan="6" class="text-center text-muted py-3">Sem dados para o período selecionado</td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>

            @if ((statsSearchResults?.detailedConsumptionTotalCount ?? 0) > pageSize) {
            <div class="table-pagination">
              <button class="page-btn" [disabled]="isTableLoading || currentPage === 1" (click)="goToPage(currentPage - 1)"
                aria-label="Página anterior">‹</button>

              @for (page of pageNumbers; track page) {
              <button class="page-btn" [class.active]="page === currentPage" [disabled]="isTableLoading" (click)="goToPage(page)">{{ page }}</button>
              }

              <button class="page-btn" [disabled]="isTableLoading || currentPage === totalPages" (click)="goToPage(currentPage + 1)"
                aria-label="Próxima página">›</button>

              <span class="page-info">
                {{ ((currentPage - 1) * pageSize) + 1 }}–{{
                currentPage * pageSize > (statsSearchResults?.detailedConsumptionTotalCount ?? 0)
                ? (statsSearchResults?.detailedConsumptionTotalCount ?? 0)
                : currentPage * pageSize
                }} de {{ statsSearchResults?.detailedConsumptionTotalCount ?? 0 }}
              </span>
            </div>
            }

            }

            <!-- Vista completa (extra columns: data doc, nº doc, morada LE, localidade LE) -->
            @if (consumptionViewMode === 'completa') {

            <div class="scrollable-table">
              <table class="table stats-table" id="consumptionDetailTable"
                aria-label="Tabela de consumo detalhado - vista completa">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>EAN</th>
                    <th>Designação</th>
                    <th>Data doc.</th>
                    <th>Nº doc</th>
                    <th>Qtd do Produto Faturada</th>
                    <th>Qtd do Produto Bónus</th>
                    @if (loggedUser.role !== 'Laboratorio') {
                    <th>Preço unitário</th>
                    <th>Desc. 1</th>
                    <th>Desc. 2</th>
                    <th>Desc. 3</th>
                    <th>Valor do Produto Faturado</th>
                    }
                    <th>{{ loggedUser.role === 'Laboratorio' ? 'Cliente' : 'Laboratório' }}</th>
                    <th>Morada LE</th>
                    <th>Localidade LE</th>
                  </tr>
                </thead>
                <tbody>
                  @for (row of consumptionTableData; track row) {
                  <tr>
                    <td>{{ row.reference ?? '—' }}</td>
                    <td>{{ row.ean || '—' }}</td>
                    <td>{{ row.designation }}</td>
                    <td>{{ row.documentDate ?? '—' }}</td>
                    <td>{{ row.documentNumber ?? '—' }}</td>
                    <td>{{ row.quantityCashed }}</td>
                    <td>{{ row.quantityBonus }}</td>
                    @if (loggedUser.role !== 'Laboratorio') {
                    <td>{{ row.unitPrice != null ? formatMoney(row.unitPrice) : '—' }}</td>
                    <td>{{ formatPercent(row.discount1) }}</td>
                    <td>{{ formatPercent(row.discount2) }}</td>
                    <td>{{ formatPercent(row.discount3) }}</td>
                    <td>{{ formatMoney(row.valueCashed) }}</td>
                    }
                    <td>{{ row.laboratoryName ?? '—' }}</td>
                    <td>{{ row.deliveryAddress ?? '—' }}</td>
                    <td>{{ row.deliveryLocality ?? '—' }}</td>
                  </tr>
                  }
                  @if (!consumptionTableData.length) {
                  <tr>
                    <td [attr.colspan]="loggedUser.role === 'Laboratorio' ? 11 : 15" class="text-center text-muted py-3">Sem dados para o período selecionado</td>
                  </tr>
                  }
                </tbody>
              </table>
            </div>

            @if ((statsSearchResults?.detailedConsumptionTotalCount ?? 0) > pageSize) {
            <div class="table-pagination">
              <button class="page-btn" [disabled]="isTableLoading || currentPage === 1" (click)="goToPage(currentPage - 1)"
                aria-label="Página anterior">‹</button>

              @for (page of pageNumbers; track page) {
              <button class="page-btn" [class.active]="page === currentPage" [disabled]="isTableLoading" (click)="goToPage(page)">{{ page }}</button>
              }

              <button class="page-btn" [disabled]="isTableLoading || currentPage === totalPages" (click)="goToPage(currentPage + 1)"
                aria-label="Próxima página">›</button>

              <span class="page-info">
                {{ ((currentPage - 1) * pageSize) + 1 }}–{{
                currentPage * pageSize > (statsSearchResults?.detailedConsumptionTotalCount ?? 0)
                ? (statsSearchResults?.detailedConsumptionTotalCount ?? 0)
                : currentPage * pageSize
                }} de {{ statsSearchResults?.detailedConsumptionTotalCount ?? 0 }}
              </span>
            </div>
            }

            }

          </div><!-- /.table-container -->
        </div>

        <!-- ─────────────────────────────────────────────────────────────────
             5. TOP 10 PRODUCTS + TOP 10 LABS  (change 5)
             ───────────────────────────────────────────────────────────────── -->
        <!-- Top 10 Products -->
        <div class="statistics-card top-chart-card">
          <div class="top-chart-header">
            <label>Top 10 Produtos (€)</label>
            <button type="button" class="export-btn export-btn-sm" (click)="DownloadTop10Products()"
              aria-label="Exportar top 10 produtos">
              Exportar dados
              <img src="../../../assets/Icons/ExportIcon.png" alt="">
            </button>
          </div>
          <div class="top-chart-body">
            <div class="top-chart-canvas-wrapper">
              <canvas #top10ProductsChart id="top10ProductsChart"></canvas>
            </div>
            <div class="top-chart-legend">
              @for (item of top10ProductsLegend; track item.label) {
              <div class="legend-row">
                <span class="legend-dot" [style.background]="item.color"></span>
                <span class="legend-label" [title]="item.label">{{ item.label }}</span>
                <span class="legend-value">{{ formatMoney(item.value) }}</span>
              </div>
              }
            </div>
          </div>
        </div>

        <!-- Top 10 Labs -->
        <div class="statistics-card top-chart-card">
          <div class="top-chart-header">
            <label>Top 10 Laboratórios (€)</label>
            <button type="button" class="export-btn export-btn-sm" (click)="DownloadTop10Labs()"
              aria-label="Exportar top 10 laboratórios">
              Exportar dados
              <img src="../../../assets/Icons/ExportIcon.png" alt="">
            </button>
          </div>
          <div class="top-chart-body">
            <div class="top-chart-canvas-wrapper">
              <canvas #top10LabsChart id="top10LabsChart"></canvas>
            </div>
            <div class="top-chart-legend">
              @for (item of top10LabsLegend; track item.label) {
              <div class="legend-row">
                <span class="legend-dot" [style.background]="item.color"></span>
                <span class="legend-label" [title]="item.label">{{ item.label }}</span>
                <span class="legend-value">{{ formatMoney(item.value) }}</span>
              </div>
              }
            </div>
          </div>
        </div>

        <!-- ─────────────────────────────────────────────────────────────────
             6. PRODUCT CARD  (change 6 — default to top product)
             ───────────────────────────────────────────────────────────────── -->
        <div class="statistics-card">
          <label class="product-card-header">Produto</label>
          <div class="stats-card-content">
            <div class="stats-grid">
              <div class="stats-grid-cell">
                <div class="stats-grid-cell-header">Designação</div>
                <div class="stats-grid-cell-value">
                  {{ defaultTopProduct?.designation || 'Nenhum selecionado' }}
                </div>
              </div>
              <div class="stats-grid-cell">
                <div class="stats-grid-cell-header">Qtd do Produto Faturada</div>
                <div class="stats-grid-cell-value">
                  {{ defaultTopProduct?.quantityCashed ?? 0 }}
                </div>
              </div>
              <div class="stats-grid-cell">
                <div class="stats-grid-cell-header">Qtd do Produto Bónus</div>
                <div class="stats-grid-cell-value">
                  {{ defaultTopProduct?.quantityBonus ?? 0 }}
                </div>
              </div>
              <div class="stats-grid-cell">
                <div class="stats-grid-cell-header">Valor do Produto Faturado</div>
                <div class="stats-grid-cell-value">
                  {{ formatMoney(defaultTopProduct?.valueCashed) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ─────────────────────────────────────────────────────────────────
             6/7. LABORATORY CARD  (change 6 default top lab; change 7 lab filter table)
             ───────────────────────────────────────────────────────────────── -->
        <div class="statistics-card mobiledisplay">
          <label class="lab-card-header">Laboratório</label>
          <div class="stats-card-content">
            <div class="stats-grid">
              <div class="stats-grid-cell">
                <div class="stats-grid-cell-header">Designação</div>
                <div class="stats-grid-cell-value">
                  {{ defaultTopLab?.label || 'Nenhum selecionado' }}
                </div>
              </div>
              @if (!activeProduct || activeLaboratory) {
              <div class="stats-grid-cell">
                <div class="stats-grid-cell-header">Qtd do Produto Faturada</div>
                <div class="stats-grid-cell-value">
                  {{ statsSearchResults?.defaultLaboratoryResult?.quantityCashed ?? 0 }}
                </div>
              </div>
              <div class="stats-grid-cell">
                <div class="stats-grid-cell-header">Qtd do Produto Bónus</div>
                <div class="stats-grid-cell-value">
                  {{ statsSearchResults?.defaultLaboratoryResult?.quantityBonus ?? 0 }}
                </div>
              </div>
              <div class="stats-grid-cell">
                <div class="stats-grid-cell-header">Valor do Produto Faturado</div>
                <div class="stats-grid-cell-value">
                  {{ formatMoney(statsSearchResults?.defaultLaboratoryResult?.valueCashed) }}
                </div>
              </div>
              }
            </div>
          </div>
        </div>

        <!-- ─────────────────────────────────────────────────────────────────
             SUBSTANCE CARD
             ───────────────────────────────────────────────────────────────── -->
        <div class="statistics-card-100">
          <label class="substance-card-header">Substância</label>
          <div class="stats-card-content">
            @if (!substanceTableVisibility) {
            <div class="stats-default-info">
              <div class="stats-grid-cell-header">Nenhum selecionado</div>
              <div class="stats-grid-cell-value">0 resultados</div>
            </div>
            } @else {
            <div class="scrollable-table-wrapper">

              <div class="scrollable-table">
                <table class="table stats-table" id="substanceTable" aria-label="Tabela de estatísticas de substâncias">
                  <thead>
                    <tr>
                      <th>Designação</th>
                      <th>Qtd do Produto Faturada</th>
                      <th>Qtd do Produto Bónus</th>
                      <th>Valor do Produto Faturado</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (sub of statsSearchResults?.substancesResults; track sub) {
                    <tr>
                      <td>{{ sub.designation }}</td>
                      <td>{{ sub.quantityCashed }}</td>
                      <td>{{ sub.quantityBonus }}</td>
                      <td>{{ formatMoney(sub.valueCashed) }}</td>
                    </tr>
                    }
                    @if (!statsSearchResults?.substancesResults?.length) {
                    <tr>
                      <td colspan="4" class="text-center text-muted py-3">Sem dados para a substância selecionada</td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            }
          </div>
        </div>


      </div><!-- /statistics-content -->
    </div><!-- /content -->

    <div class="app-backdrop" [ngClass]="{ 'open': isMenuOpen || isModalOpen }" (click)="closeMenu()"></div>
    <app-footer></app-footer>
  </div>
</div>